import React, {Fragment} from 'react';
import Navigation from "./Navigation";
import TrackingHeader from "./TrackingHeader";
import CardBalanceContent from './CardbalanceContent';
import Footer from './Footer';
const MyVisaCard = () => {
    return (
        <Fragment>
            <Navigation />
            <TrackingHeader />
            <CardBalanceContent />
            <Footer />
        </Fragment>
    );
}
export default MyVisaCard;